import React from 'react'
import { FilterListAccordion } from './FilterListAccordion'
import { MultiCheckboxFilterList } from '../Widgets/MultiCheckboxFilterList'
import { ToggleFilter } from './ToggleFilter'
import SortList from './SortList'
import PriceRangeSlider from './PriceRangeSlider'
import { useIntl } from '@jetshop/intl'
import { DIGIFI_FILTER_FIELD_NAMES, DIGIFI_SORT_VALUES } from '../../DigifiSearch/constants'

const FilterList = ({
   filters,
   updateFilters,
   facets,
   hideFilters = [],
}) => {
   const t = useIntl()
   
   return (
      <>
         {!hideFilters.includes(DIGIFI_FILTER_FIELD_NAMES.BRAND) && (
            <FilterListAccordion
               title={`${t('brand')}`}
               isOpen={false}
               isEmpty={!facets?.brandFacets?.length}
            >
               <MultiCheckboxFilterList
                  fieldName={DIGIFI_FILTER_FIELD_NAMES.BRAND}
                  filters={filters}
                  options={facets?.brandFacets}
                  isSelected={({ filters, fieldName, value }) =>
                     filters?.some(
                        f =>
                           f?.fieldName === fieldName && f?.value?.includes(value)
                     )
                  }
                  onChange={({ fieldName, value }) => {
                     updateFilters?.([
                        {
                           fieldName: fieldName,
                           value: value,
                        },
                     ])
                  }}
               />
            </FilterListAccordion>
         )}
         
         {!hideFilters.includes(DIGIFI_FILTER_FIELD_NAMES.PREBOOK) && (
            <FilterListAccordion title={t('stock-status')} isOpen={false} isEmpty={false}>
               <ToggleFilter
                  filters={filters}
                  fieldName={DIGIFI_FILTER_FIELD_NAMES.PREBOOK}
                  label={t('book in advance')}
                  onToggleChange={({ fieldName, value }) => {
                     updateFilters([
                        {
                           fieldName,
                           value,
                        },
                     ])
                  }}
                  isChecked={({ fieldName, filters }) =>
                     filters?.some(
                        f =>
                           f?.fieldName === fieldName &&
                           (f.value === true || f.value === 'true')
                     )
                  }
               />
            </FilterListAccordion>
         )}
         
         {!hideFilters.includes(DIGIFI_FILTER_FIELD_NAMES.SORT_BY) && (
            <FilterListAccordion title={t('sorting')} isOpen={false} isEmpty={false}>
               <SortList
                  fieldName={DIGIFI_FILTER_FIELD_NAMES.SORT_BY}
                  options={[
                     { label: 'Relevans', value: DIGIFI_SORT_VALUES.RELEVANCE },
                     {
                        label: t('Price-low-to-high'),
                        value: DIGIFI_SORT_VALUES.PRICE_ASC,
                     },
                     {
                        label: t('Price-high-to-low'),
                        value: DIGIFI_SORT_VALUES.PRICE_DESC,
                     }
                     // {
                     //    label: 'TestFreaksRating (asc)',
                     //    value: SORT_VALUES.RATING_ASC,
                     // },
                     // {
                     //    label: 'TestFreaksRating (desc)',
                     //    value: SORT_VALUES.RATING_DESC,
                     // },
                  ]}
                  filters={filters}
                  isSelected={({ fieldName, value, filters }) => {
                     if (value === '') {
                        // No sort filter active, set deafult filter in ui
                        return !filters.some(f => f.fieldName === fieldName)
                     }
                     return filters.some(
                        f => f.fieldName === fieldName && f.value === value
                     )
                  }}
                  onSortChange={({ fieldName, value }) =>
                     updateFilters?.([
                        {
                           fieldName: fieldName,
                           value,
                        },
                     ])
                  }
               />
            </FilterListAccordion>
         )}
         
         {!hideFilters.includes(DIGIFI_FILTER_FIELD_NAMES.PRICE) && (
            <FilterListAccordion title={t('Price')} isOpen={true} isEmpty={false}>
               <PriceRangeSlider
                  filters={filters}
                  facets={facets}
                  handleChange={values => {
                     if(values[0] == values[1]) {
                        return;
                     }
                     updateFilters?.([
                        {
                           fieldName: DIGIFI_FILTER_FIELD_NAMES.PRICE,
                           value: values,
                        },
                     ])
                  }}
               />
            </FilterListAccordion>
         )}
      </>
   )
}

export default FilterList
